import { Module } from "vuex";
import { RootState } from "../types";
import { MyCourseState } from "./types";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";

export const state: MyCourseState = {};

const namespaced: boolean = true;

export const myCourse: Module<MyCourseState, RootState> = {
  namespaced,
  state,
  actions,
  getters,
  mutations,
};
